"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BuildInfo = void 0;
var React = require("react");
var BuildInfo = function (props) {
    var clientLabel = props.clientLabel, clientVersion = props.clientVersion, serverLabel = props.serverLabel, serverVersion = props.serverVersion;
    return (React.createElement("div", { className: "sok-build-info" },
        React.createElement("span", null,
            clientLabel,
            ": ",
            clientVersion),
        React.createElement("span", null,
            serverLabel,
            ": ",
            serverVersion)));
};
exports.BuildInfo = BuildInfo;
//# sourceMappingURL=index.js.map